import { Component, Input, ViewChild } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { ReportResponse } from '../../shared/domain/report/report-response.model';
import { KnMainTableComponent } from '../../shared/components/widgets/main-table/kn-main-table.component';
import { KitchenDashboardService } from '../kitchen-dashboard.service';
import {MomentDateUtils} from '../../../shared/utils/moment-date-utils';

@Component({
  selector: 'cm-kn-dashboard-table',
  templateUrl: './kn-dashboard-table.component.html',
  host: { 'class': 'cm-kn-dashboard-table' }
})
export class KnDashboardTableComponent {
  @ViewChild('table', { static: true }) table: KnMainTableComponent;
  _loading: boolean;

  @Input('loading')
  set loading(loading) {
    this._loading = loading;
  }

  @Input()
  set data(data: ReportResponse) {
    this.table.renderData(data);
  }

  dateFrom = MomentDateUtils.today();
  dateTo = MomentDateUtils.today();

  constructor(private dashboardService: KitchenDashboardService,
              private route: ActivatedRoute,
              private router: Router) {

    this.route
      .queryParams
      .subscribe(params => {
        this.dateFrom = params['dateFrom'] ? params['dateFrom'] : MomentDateUtils.today();
        this.dateTo = params['dateTo'] ? params['dateTo'] : MomentDateUtils.today();
      });
  }

  onClickRefreshTableData() {
    this._loading = true;
    this.dashboardService.getDashData(this.dateFrom, this.dateTo).subscribe(next => {
      this._loading = false;
      this.table.renderData(next);
    }, () => {
      this._loading = false;
    });
  }
}
